<div #sentinel class="tiptap-toolbar-sentinel"></div>
<div
    #toolbarElement
    class="tiptap-toolbar"
    [class.tiptap-toolbar--sticky]="isSticky"
    [class.tiptap-toolbar--hidden]="!isToolbarVisible"
    [style.width]="isSticky ? toolbarWidth : 'auto'"
    [style.top]="isSticky ? toolbarTop : null"
    *ngIf="editor"
    (mouseleave)="closeMenus()"
>
    <div class="tiptap-group">
        <button type="button" class="tiptap-button" (click)="tiptapUndo()" title="Undo">
            <ham-tiptap-icon icon="undo"></ham-tiptap-icon>
            <span class="tiptap-button-label">Undo</span>
        </button>
        <button type="button" class="tiptap-button" (click)="tiptapRedo()" title="Redo">
            <ham-tiptap-icon icon="redo"></ham-tiptap-icon>
            <span class="tiptap-button-label">Redo</span>
        </button>
    </div>
    <div class="tiptap-divider"></div>
    <div class="tiptap-group">
        <button type="button" class="tiptap-button is-strong" (click)="tiptapToggleBold()" title="Bold">
            <ham-tiptap-icon icon="bold"></ham-tiptap-icon>
            <span class="tiptap-button-label">Bold</span>
        </button>
        <button type="button" class="tiptap-button is-italic" (click)="tiptapToggleItalic()" title="Italic">
            <ham-tiptap-icon icon="italic"></ham-tiptap-icon>
            <span class="tiptap-button-label">Italic</span>
        </button>
        <button type="button" class="tiptap-button is-underline" (click)="tiptapToggleUnderline()" title="Underline">
            <ham-tiptap-icon icon="underline"></ham-tiptap-icon>
            <span class="tiptap-button-label">Underline</span>
        </button>
        <button type="button" class="tiptap-button is-strike" (click)="tiptapToggleStrike()" title="Strike">
            <ham-tiptap-icon icon="strikethrough"></ham-tiptap-icon>
            <span class="tiptap-button-label">Strike</span>
        </button>
        <button type="button" class="tiptap-button" (click)="tiptapRemoveFormat()" title="Clear formatting">
            <ham-tiptap-icon icon="remove-formatting"></ham-tiptap-icon>
            <span class="tiptap-button-label">Clear</span>
        </button>
    </div>
    <div class="tiptap-divider"></div>
    <div class="tiptap-group">
        <button type="button" class="tiptap-button" (click)="toggleParagraphMenu()" title="Paragraph">
            <ham-tiptap-icon icon="pilcrow"></ham-tiptap-icon>
            <span class="tiptap-button-label">Paragraph</span>
        </button>
        <div class="tiptap-menu" *ngIf="isParagraphMenuOpen">
            <button type="button" class="tiptap-menu-item" (click)="tiptapToggleHeading(1)">Heading 1</button>
            <button type="button" class="tiptap-menu-item" (click)="tiptapToggleHeading(2)">Heading 2</button>
            <button type="button" class="tiptap-menu-item" (click)="tiptapToggleHeading(3)">Heading 3</button>
            <button type="button" class="tiptap-menu-item" (click)="tiptapToggleBlockquote()">Quote</button>
        </div>
    </div>
    <div class="tiptap-group">
        <button type="button" class="tiptap-button" (click)="toggleAlignMenu()" title="Alignment">
            <ham-tiptap-icon icon="text-align-start"></ham-tiptap-icon>
            <span class="tiptap-button-label">Align</span>
        </button>
        <div class="tiptap-menu" *ngIf="isAlignMenuOpen">
            <button type="button" class="tiptap-menu-item" (click)="tiptapSetAlign('left')">
                <ham-tiptap-icon icon="text-align-start" size="14"></ham-tiptap-icon>
                <span class="tiptap-button-label">Left</span>
            </button>
            <button type="button" class="tiptap-menu-item" (click)="tiptapSetAlign('center')">
                <ham-tiptap-icon icon="text-align-center" size="14"></ham-tiptap-icon>
                <span class="tiptap-button-label">Center</span>
            </button>
            <button type="button" class="tiptap-menu-item" (click)="tiptapSetAlign('right')">
                <ham-tiptap-icon icon="text-align-end" size="14"></ham-tiptap-icon>
                <span class="tiptap-button-label">Right</span>
            </button>
            <button type="button" class="tiptap-menu-item" (click)="tiptapSetAlign('justify')">
                <ham-tiptap-icon icon="text-align-justify" size="14"></ham-tiptap-icon>
                <span class="tiptap-button-label">Justify</span>
            </button>
        </div>
    </div>
    <div class="tiptap-divider"></div>
    <div class="tiptap-group">
        <button type="button" class="tiptap-button" (click)="tiptapToggleBulletList()" title="Bullets">
            <ham-tiptap-icon icon="list"></ham-tiptap-icon>
            <span class="tiptap-button-label">Bullets</span>
        </button>
        <button type="button" class="tiptap-button" (click)="tiptapToggleOrderedList()" title="Numbered">
            <ham-tiptap-icon icon="list-ordered"></ham-tiptap-icon>
            <span class="tiptap-button-label">Numbered</span>
        </button>
        <button type="button" class="tiptap-button" (click)="tiptapIndent()" title="Indent">
            <ham-tiptap-icon icon="list-indent-increase" size="18"></ham-tiptap-icon>
            <span class="tiptap-button-label">Indent</span>
        </button>
        <button type="button" class="tiptap-button" (click)="tiptapOutdent()" title="Outdent">
            <ham-tiptap-icon icon="list-indent-decrease" size="18"></ham-tiptap-icon>
            <span class="tiptap-button-label">Outdent</span>
        </button>
    </div>
    <div class="tiptap-divider"></div>
    <div class="tiptap-group">
        <button type="button" class="tiptap-button" (click)="tiptapInsertImage()" title="Image">
            <ham-tiptap-icon icon="image"></ham-tiptap-icon>
            <span class="tiptap-button-label">Image</span>
        </button>
        <input #imageInput type="file" accept="image/*" (change)="onImageSelected($event)" hidden />

        <button type="button" class="tiptap-button" (click)="tiptapInsertPageBreak()" title="Page break">
            <ham-tiptap-icon icon="separator-horizontal"></ham-tiptap-icon>
            <span class="tiptap-button-label">Page break</span>
        </button>
        <button type="button" class="tiptap-button" (click)="tiptapInsertTabSpan()" title="Tab">
            <ham-tiptap-icon icon="corner-down-right"></ham-tiptap-icon>
            <span class="tiptap-button-label">Tab</span>
        </button>
    </div>
    <div class="tiptap-group">
        <button type="button" class="tiptap-button" (click)="tiptapInsertTable()" title="Insert table">
            <ham-tiptap-icon icon="table"></ham-tiptap-icon>
            <span class="tiptap-button-label">Insert table</span>
        </button>
    </div>
    <div class="tiptap-group">
        <button type="button" class="tiptap-button" (click)="tiptapSelectAll()" title="Select all">
            <ham-tiptap-icon icon="text-select"></ham-tiptap-icon>
            <span class="tiptap-button-label">Select all</span>
        </button>
    </div>
</div>
<div
    #surfaceElement
    class="tiptap-surface"
    (click)="onSurfaceClick($event)"
    (mousemove)="onSurfacePointer($event)"
    (mouseleave)="onSurfaceLeave()"
>
    <div
        #tableToolbarElement
        class="tiptap-table-toolbar"
        *ngIf="editor && isInTable()"
        [style.top]="isTableToolbarSticky ? tableToolbarStickyTop : (tableToolbarTop + 'px')"
        [style.left]="isTableToolbarSticky ? tableToolbarStickyLeft : null"
        [style.width]="isTableToolbarSticky ? tableToolbarStickyWidth : null"
        [class.tiptap-table-toolbar--visible]="isTableToolbarVisible"
        [class.tiptap-table-toolbar--sticky]="isTableToolbarSticky"
    >
        <div class="tiptap-group">
            <button type="button" class="tiptap-button" (click)="tiptapToggleHeaderRow()" title="Header row">
                <ham-tiptap-icon icon="table-rows-split"></ham-tiptap-icon>
                <span class="tiptap-button-label">Header row</span>
            </button>
            <button type="button" class="tiptap-button" (click)="tiptapToggleHeaderColumn()" title="Header column">
                <ham-tiptap-icon icon="table-columns-split"></ham-tiptap-icon>
                <span class="tiptap-button-label">Header column</span>
            </button>
        </div>
        <div class="tiptap-divider"></div>
        <div class="tiptap-group">
            <button type="button" class="tiptap-button" (click)="toggleColumnMenu()" title="Column">
                <ham-tiptap-icon icon="columns"></ham-tiptap-icon>
                <span class="tiptap-button-label">Column</span>
            </button>
            <div class="tiptap-menu" *ngIf="isColumnMenuOpen">
                <button type="button" class="tiptap-menu-item" (click)="tiptapAddColumnBefore()">
                    <ham-tiptap-icon icon="arrow-left" size="14"></ham-tiptap-icon>
                    <span class="tiptap-button-label">Insert left</span>
                </button>
                <button type="button" class="tiptap-menu-item" (click)="tiptapAddColumnAfter()">
                    <ham-tiptap-icon icon="arrow-right" size="14"></ham-tiptap-icon>
                    <span class="tiptap-button-label">Insert right</span>
                </button>
                <button type="button" class="tiptap-menu-item" (click)="tiptapDeleteColumn()">
                    <ham-tiptap-icon icon="trash-2" size="14"></ham-tiptap-icon>
                    <span class="tiptap-button-label">Delete</span>
                </button>
            </div>
        </div>
        <div class="tiptap-group">
            <button type="button" class="tiptap-button" (click)="toggleRowMenu()" title="Row">
                <ham-tiptap-icon icon="rows"></ham-tiptap-icon>
                <span class="tiptap-button-label">Row</span>
            </button>
            <div class="tiptap-menu" *ngIf="isRowMenuOpen">
                <button type="button" class="tiptap-menu-item" (click)="tiptapAddRowBefore()">
                    <ham-tiptap-icon icon="arrow-up" size="14"></ham-tiptap-icon>
                    <span class="tiptap-button-label">Insert above</span>
                </button>
                <button type="button" class="tiptap-menu-item" (click)="tiptapAddRowAfter()">
                    <ham-tiptap-icon icon="arrow-down" size="14"></ham-tiptap-icon>
                    <span class="tiptap-button-label">Insert below</span>
                </button>
                <button type="button" class="tiptap-menu-item" (click)="tiptapDeleteRow()">
                    <ham-tiptap-icon icon="trash-2" size="14"></ham-tiptap-icon>
                    <span class="tiptap-button-label">Delete</span>
                </button>
            </div>
        </div>
        <div class="tiptap-divider"></div>
        <div class="tiptap-group">
            <button type="button" class="tiptap-button" (click)="tiptapMergeCells()" title="Merge cells">
                <ham-tiptap-icon icon="table-cells-merge"></ham-tiptap-icon>
                <span class="tiptap-button-label">Merge</span>
            </button>
            <button type="button" class="tiptap-button" (click)="tiptapSplitCell()" title="Split cell">
                <ham-tiptap-icon icon="table-cells-split"></ham-tiptap-icon>
                <span class="tiptap-button-label">Split</span>
            </button>
            <button type="button" class="tiptap-button" (click)="tiptapDeleteTable()" title="Delete table">
                <ham-tiptap-icon icon="table"></ham-tiptap-icon>
                <span class="tiptap-button-label">Delete table</span>
            </button>
        </div>
        <div class="tiptap-divider"></div>
        <div class="tiptap-group">
            <button type="button" class="tiptap-button" (click)="tiptapToggleCellAlignMenu()" title="Cell align">
                <ham-tiptap-icon icon="align-horizontal-distribute-center"></ham-tiptap-icon>
                <span class="tiptap-button-label">Cell align</span>
            </button>
            <div class="tiptap-menu" *ngIf="isCellAlignMenuOpen">
                <button type="button" class="tiptap-menu-item" (click)="tiptapSetCellAlign('left')">
                    <ham-tiptap-icon icon="text-align-start" size="14"></ham-tiptap-icon>
                    <span class="tiptap-button-label">Left</span>
                </button>
                <button type="button" class="tiptap-menu-item" (click)="tiptapSetCellAlign('center')">
                    <ham-tiptap-icon icon="text-align-center" size="14"></ham-tiptap-icon>
                    <span class="tiptap-button-label">Center</span>
                </button>
                <button type="button" class="tiptap-menu-item" (click)="tiptapSetCellAlign('right')">
                    <ham-tiptap-icon icon="text-align-end" size="14"></ham-tiptap-icon>
                    <span class="tiptap-button-label">Right</span>
                </button>
                <button type="button" class="tiptap-menu-item" (click)="tiptapSetCellAlign(null)">Reset</button>
            </div>
        </div>
        <div class="tiptap-group">
            <button type="button" class="tiptap-button" (click)="tiptapToggleCellVerticalMenu()" title="Cell vertical">
                <ham-tiptap-icon icon="align-vertical-space-between"></ham-tiptap-icon>
                <span class="tiptap-button-label">Cell vertical</span>
            </button>
            <div class="tiptap-menu" *ngIf="isCellVerticalMenuOpen">
                <button type="button" class="tiptap-menu-item" (click)="tiptapSetCellVerticalAlign('top')">Top</button>
                <button type="button" class="tiptap-menu-item" (click)="tiptapSetCellVerticalAlign('middle')">
                    Middle
                </button>
                <button type="button" class="tiptap-menu-item" (click)="tiptapSetCellVerticalAlign('bottom')">
                    Bottom
                </button>
                <button type="button" class="tiptap-menu-item" (click)="tiptapSetCellVerticalAlign(null)">Reset</button>
            </div>
        </div>
        <div class="tiptap-divider"></div>
        <div class="tiptap-group">
            <button type="button" class="tiptap-button" (click)="toggleColumnStyleMenu()" title="Column styles">
                <ham-tiptap-icon icon="columns-3"></ham-tiptap-icon>
                <span class="tiptap-button-label">Column styles</span>
            </button>
            <div class="tiptap-menu" *ngIf="isColumnStyleMenuOpen">
                <button type="button" class="tiptap-menu-item" (click)="tiptapColumnTotal()">
                    <ham-tiptap-icon icon="sigma" size="14"></ham-tiptap-icon>
                    <span class="tiptap-button-label">Total</span>
                </button>
                <button type="button" class="tiptap-menu-item" (click)="tiptapColumnHighlight()">
                    <ham-tiptap-icon icon="highlighter" size="14"></ham-tiptap-icon>
                    <span class="tiptap-button-label">Highlight</span>
                </button>
                <button type="button" class="tiptap-menu-item" (click)="tiptapColumnNumber()">
                    <ham-tiptap-icon icon="percent" size="14"></ham-tiptap-icon>
                    <span class="tiptap-button-label">Number</span>
                </button>
                <button type="button" class="tiptap-menu-item" (click)="tiptapClearColumnStyles()">
                    <ham-tiptap-icon icon="eraser" size="14"></ham-tiptap-icon>
                    <span class="tiptap-button-label">Clear</span>
                </button>
            </div>
        </div>
        <div class="tiptap-group">
            <button type="button" class="tiptap-button" (click)="toggleRowStyleMenu()" title="Row styles">
                <ham-tiptap-icon icon="rows-3"></ham-tiptap-icon>
                <span class="tiptap-button-label">Row styles</span>
            </button>
            <div class="tiptap-menu" *ngIf="isRowStyleMenuOpen">
                <button type="button" class="tiptap-menu-item" (click)="tiptapRowTotal()">
                    <ham-tiptap-icon icon="sigma" size="14"></ham-tiptap-icon>
                    <span class="tiptap-button-label">Total</span>
                </button>
                <button type="button" class="tiptap-menu-item" (click)="tiptapClearRowStyles()">
                    <ham-tiptap-icon icon="eraser" size="14"></ham-tiptap-icon>
                    <span class="tiptap-button-label">Clear</span>
                </button>
            </div>
        </div>
    </div>
    <ng-content></ng-content>
</div>
